module.exports = __webpack_public_path__ + "img/NMLS-logo.8c18f78d.png";